<template>
    <div>
        <q-dialog position="right" v-model="dialog">
            <q-card style="min-width: 1200px !important; height: 95vh;">
                <q-card-section>
                    <div class="row">
                        <div class="d-flex col-12 q-pa-md pt-0" style="justify-content: space-between; align-items: center ">
                            <div>
                                <h4 style="font-size: 22px; font-weight: 300;">
                                    Due Details
                                </h4>
                            </div>
                            <div class="drawerButtons" style="margin-top: -10px;">
                                <q-btn @click="dialog=false" flat icon="close" round size="small"></q-btn>
                            </div>
                        </div>

                        <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                            <ul style="list-style: none">
                                <li class="pb-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Order ID</span>
                                    <h4 style="font-size: 24px; font-weight: 400">{{selectedOrderObj.orderNum?selectedOrderObj.orderNum:'-'}}</h4>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Placed By</span>
                                    <span>{{selectedOrderObj.PlacedBy?selectedOrderObj.PlacedBy.name:'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Partner Type</span>
                                    <span>{{selectedOrderObj.FromOrganization?selectedOrderObj.FromOrganization.PartnerType.prefix:'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Order From</span>
                                    <span>{{selectedOrderObj.FromOrganization?selectedOrderObj.FromOrganization.name:'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Order Date</span>
                                    <span>{{selectedOrderObj.date?dateFilter(selectedOrderObj.date):'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Created on</span>
                                    <span>{{selectedOrderObj.createdOn?dateTimeFilter(selectedOrderObj.createdOn):'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice No</span>
                                    <span>{{selectedOrderObj.invoiceNumber?selectedOrderObj.invoiceNumber:'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice Date</span>
                                    <span>{{selectedOrderObj.invoiceDate?dateFilter(selectedOrderObj.invoiceDate):'-'}}</span>
                                </li>
                                <li class="py-3" style="border-bottom: 1px solid #e0e0e0">
                                    <span class="bankLabel d-block">Invoice Note</span>
                                    <span>{{selectedOrderObj.invoiceNote?selectedOrderObj.invoiceNote:'-'}}</span>
                                </li>

                            </ul>

                            <!--<p>Order ID: {{selectedOrderObj.orderNum}}</p>-->
                            <!--<p>Invoice No:{{selectedOrderObj.invoiceNumber?selectedOrderObj.invoiceNumber:'-'}}</p>-->
                            <!--<p>Invoice Date: {{selectedOrderObj.createdOn?dateFilter(selectedOrderObj.invoiceDate):'-'}}</p>-->
                            <!--<p>Order From: {{selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length?selectedOrderObj.OrderItems[0].FromOrganization.name:'-'}}</p>-->
                            <!--<p>Order on: {{selectedOrderObj.createdOn?dateTimeFilter(selectedOrderObj.createdOn):'-'}}</p>-->

                            <!--<p>Order ID: {{selectedOrderObj.orderNum}}</p>-->
                            <!--<p>Invoice No:{{selectedOrderObj.invoiceNumber?selectedOrderObj.invoiceNumber:'-'}}</p>-->
                            <!--<p>Invoice Date: {{selectedOrderObj.createdOn?dateFilter(selectedOrderObj.invoiceDate):'-'}}</p>-->
                            <!--<p>Order To: {{selectedOrderObj.OrderItems&&selectedOrderObj.OrderItems.length?selectedOrderObj.OrderItems[0].ToOrganization.name:'-'}}</p>-->
                            <!--<p>Order on: {{selectedOrderObj.createdOn?dateTimeFilter(selectedOrderObj.createdOn):'-'}}</p>-->
                        </div>

                        <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                            <h6 style="margin-top: -18px;margin-bottom: 10px;">Total Items :
                            {{selectedOrderObj.OrderItems?selectedOrderObj.OrderItems.length:0}}</h6>
                            <div v-show="batch_loader">
                                <q-inner-loading :showing="true"
                                                 style="top: 200px;width: 430px;height: 40px;left: 450px;">
                                    <q-spinner-dots color="primary" size="50px"></q-spinner-dots>
                                </q-inner-loading>
                            </div>
                            <q-list bordered class="rounded-borders" v-if="productArr && productArr.length">
                                <template v-for="(product, index) in productArr" v-if="product.OrderItems.length">
                                    <q-expansion-item>
                                        <template slot="header">
                                            <q-item-section>
                                                {{product.name}}
                                                <!--({{product.productLineName}}-{{product.OemName}})-->
                                            </q-item-section>
                                            <q-item-section side>{{product.OrderItems.length}}</q-item-section>
                                        </template>

                                        <q-card>
                                            <q-card-section>
                                                <q-list bordered padding>
                                                    <q-item :key="i" tag="label"
                                                            v-for="(orderItem, i) in product.OrderItems">
                                                        <q-item-section side top>
                                                        </q-item-section>

                                                        <q-item-section>
                                                            <q-item-label>{{orderItem.Batch.batch}}
                                                                <span style="float:right;"></span>
                                                            </q-item-label>
                                                            <q-item-label caption>{{product.productLineCode}}
                                                            </q-item-label>
                                                        </q-item-section>
                                                    </q-item>
                                                </q-list>
                                            </q-card-section>
                                        </q-card>

                                    </q-expansion-item>
                                </template>
                            </q-list>
                        </div>
                    </div>
                </q-card-section>

            </q-card>
        </q-dialog>


        <div class="row">
            <div class="col-12 pt-0 " :key="index" v-for="(order, index) in Orders">
                <q-card @click="openOrderDetail(order)" class="product-card mb-3" >
            <q-card-section>
                <div @click="openOrderDetail(order)" class="mp-card">
                    <div  class="mp-header">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex">
                                <div class="text-left mr-5">
                                    <span class="bankLabel">Order ID</span>
                                    <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                                        {{order.orderNum}}
                                    </h4>
                                </div>
                                <div class="ml-5 text-left">
                                    <span class="bankLabel">Placed By</span>
                                    <h4 style="font-size: 16px; line-height: 1.5rem; font-weight: 100; ">
                                        {{order.PlacedBy?order.PlacedBy.name:'-'}}
                                    </h4>
                                </div>
                                <div class="ml-5 text-left">
                                    <span class="bankLabel">Partner Type</span>
                                    <h4 style="font-size: 16px; line-height: 1.5rem; font-weight: 100; ">
                                        {{order.FromOrganization?order.FromOrganization.PartnerType.prefix:'-'}}
                                    </h4>
                                </div>
                            </div>
                            <!--<div class="mp-actions d-flex">-->
                                <!--<div @click="onAcceptOrderBatches(order.productArr)" class="mp-approve">-->
                                    <!--<i class="material-icons">-->
                                        <!--done-->
                                    <!--</i>-->
                                <!--</div>-->
                                <!--<div @click="onRejectOrderBatches(order.productArr)" class="mp-reject">-->
                                    <!--<i class="material-icons">-->
                                        <!--close-->
                                    <!--</i>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="mp-items">-->
                            <!--<span>{{order.totalBatchcount}}</span>-->
                            <!--<q-tooltip>-->
                            <!--Items-->
                            <!--</q-tooltip>-->
                            <!--</div>-->
                        </div>
                    </div>
                    <hr class="my-2" style="border: 0.5px solid lightgray">

                    <div class="mp-body">
                        <ul>
                            <div class="d-flex justify-content-between" style="align-items: center">
                                <div class="d-flex py-2">
                                    <li>
                                        <div class="">
                                            <span class="bankLabel">Order From</span>
                                            <div class="mp-value">
                                                <span>{{order.FromOrganization?order.FromOrganization.name:'-'}}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                        <div class="">
                                            <!--<div class="mp-icon">-->
                                            <!--<i class="material-icons">-->
                                            <!--supervised_user_circle-->
                                            <!--</i>-->
                                            <!--</div>-->
                                            <span class="bankLabel">Order To</span>
                                            <div class="mp-value">
                                                <span>{{order.ToOrganization?order.ToOrganization.name:'-'}}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                        <div class=" ">
                                            <span class="bankLabel">Order Date</span>
                                            <div class="mp-value">
                                                <span>{{order.date?dateFilter(order.date):'-'}}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                        <div class=" ">
                                            <span class="bankLabel">Created On</span>
                                            <div class="mp-value">
                                                <span>{{order.createdOn?dateTimeFilter(order.createdOn):'-'}}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                        <div class="">
                                            <span class="bankLabel">Invoice Number</span>
                                            <div class="d-flex ">
                                                <div class="mp-value">
                                                    <span>{{order.invoiceNumber?order.invoiceNumber:'-'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li style="margin-left: 70px;">
                                        <div class="">
                                            <span class="bankLabel">Invoice Date</span>
                                            <div class="d-flex ">
                                                <div class="mp-value">
                                                    <span>{{order.invoiceDate?dateFilter(order.invoiceDate):'-'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </div>
                                <div>
<!--                                    <div class="mp-items mx-auto" @click="openOrderDetail(order)">-->
                                    <span class="mp-item-count">{{order.OrderItems.length}} {{order.OrderItems.length>1?'Items':'Item'}}</span>
<!--                                        <span class="go"><i class="material-icons">arrow_right_alt</i></span>-->
<!--                                    </div>-->
                                </div>

                            </div>


                        </ul>
<!--                        <div class="w-100 mt-3 ">-->
<!--                            &lt;!&ndash;<div class="mp-icon">&ndash;&gt;-->
<!--                            &lt;!&ndash;<i class="fab fa-product-hunt"></i>&ndash;&gt;-->
<!--                            &lt;!&ndash;</div>&ndash;&gt;-->
<!--                            <div class="d-flex ">-->
<!--                                <div class="mp-items mx-auto" @click="openOrderDetail(order)">-->
<!--                                    <span class="mp-item-count">{{order.totalBatchcount}} {{order.totalBatchcount>1?'Items':'Item'}}</span>-->
<!--                                    <span class="go"><i class="material-icons">arrow_right_alt</i></span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>


                </div>
            </q-card-section>


        </q-card>
            </div>
            <div v-if="order_loader">
                <div class="row justify-center q-my-md">
                    <q-spinner-dots color="primary" size="40px"/>
                </div>
            </div>
        </div>


        <div v-if="!Orders.length">
            <img src="../../assets/no_Data.png" style="width: 25%;" class="d-block mx-auto " alt="">
            <h6 class="text-center">No data available</h6>
        </div>

    </div>
</template>

<script>
  import { GET_ORDER_BATCHES_GROUPBY_PRODUCT } from '../../graphql/queries/Orders'
  import { SUBSCRIBE_DUE_ORDERS, SUBSCRIBE_ORDERS_TOTALCOUNT_PURCHASEDETAIL } from '../../graphql/subscription/Orders'
  import { UPDATE_ORDER } from '../../graphql/mutations/Order'

  export default {
    apollo: {
        $subscribe: {
            ordersCount: {
                query: SUBSCRIBE_ORDERS_TOTALCOUNT_PURCHASEDETAIL,
                variables () {
                    return {
                        orgId: this.userObj.orgId, filter: this.combineFilter, status: 'Sold'
                    }
                },
                result ({ data }) {
                    this.totalOrdercount = data.ordersCount.aggregate.count
                    this.$emit('ordersCount', this.totalOrdercount)
                },
            },
            Orders: {
                query: SUBSCRIBE_DUE_ORDERS,
                skip: true,
                variables () {
                    return {
                        orgId: this.userObj.orgId, offset: 0,
                        limit: this.limit, filter: this.combineFilter,
                    }
                },
                result ({ data }) {
                    this.Orders = data.Orders
                    this.order_loader = false
                },
            },
        },
    },
    name: 'DueInventory',
    props:['filter'],
    data: function () {
      return {
        userObj: JSON.parse(localStorage.getItem('user')),
        dialog: false,
        selectedOrderObj: '',
        Orders: [],
        productArr: [],
        batch_loader: false,        //For orderDetail dialog
        totalOrdercount: 10,
        offset: 0,
        limit: 10,
        order_loader: true,
        combineFilter: '%%',
      }
    },
    watch:{
        'filter': function (val) {
            this.Orders = []
            this.order_loader = true
            this.limit = 10                     //Reset limit when Search
            this.combineFilter = '%' + val + '%'
        },
        '$parent.tab': function (val) {
            if(val === this.$options.name && !this.Orders.length) {        //First time open this tab
                this.$apollo.subscriptions.Orders.skip = false
            }
        },
    },
    methods: {
        openOrderDetail (order) {
            this.selectedOrderObj = order
            this.productArr = []
            this.batch_loader = true
            this.dialog = true
            setTimeout(() => {
                this.getOrderBatchesGroupByProduct(order.id)
            }, 400)
        },
        async getOrderBatchesGroupByProduct (orderId) {
            let response = await this.$apollo.query({
                query: GET_ORDER_BATCHES_GROUPBY_PRODUCT,
                fetchPolicy: 'network-only',
                variables: { orderId: orderId },
            })
            if (response.data) {
                this.productArr = response.data.Product
                this.batch_loader = false
            }
        },
        fetchMoreOrders () {
            if(this.Orders.length < this.totalOrdercount && this.Orders.length === this.limit) {
                this.order_loader = true
                this.limit = this.limit + 10
            }
        },
        async changeOrderStatusToSold (order) {
        let response = await this.$apollo.mutate({
          mutation: UPDATE_ORDER,
          variables: {
            id: order.id,
            status: 'Sold',
          },
        })
        if (response.data) {
          this.$q.notify('Order sold successfully')
        }
      },
    },
  }
</script>

<style scoped>

</style>
